import { createGlobalStyle } from "styled-components";

import NexaBoldOtf from "@/assets/styles/fonts/Nexa-Bold.otf";
import NexaBoldWoff from "@/assets/styles/fonts/Nexa-Bold.woff";
import NexaBoldWoff2 from "@/assets/styles/fonts/Nexa-Bold.woff2";
import NexaBoldItalicOtf from "@/assets/styles/fonts/Nexa-Bold-Italic.otf";
import NexaBoldItalicWoff from "@/assets/styles/fonts/Nexa-Bold-Italic.woff";
import NexaBoldItalicWoff2 from "@/assets/styles/fonts/Nexa-Bold-Italic.woff2";
import NexaRegularOtf from "@/assets/styles/fonts/Nexa-Regular.otf";
import NexaRegularWoff from "@/assets/styles/fonts/Nexa-Regular.woff";
import NexaRegularWoff2 from "@/assets/styles/fonts/Nexa-Regular.woff2";
import NexaItalicOtf from "@/assets/styles/fonts/Nexa-Regular-Italic.otf";
import NexaItalicWoff from "@/assets/styles/fonts/Nexa-Regular-Italic.woff";
import NexaItalicWoff2 from "@/assets/styles/fonts/Nexa-Regular-Italic.woff2";

import { breakpoints } from "./breakpoints";

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: "Nexa";
        font-style: normal;
        font-weight: 400;
        src: url(${NexaRegularOtf}), url(${NexaRegularWoff2}) format("woff2"),
        url(${NexaRegularWoff}) format("woff");
        font-display: swap;
    }

    @font-face {
        font-family: "Nexa";
        font-style: italic;
        font-weight: 400;
        src: url(${NexaItalicOtf}), url(${NexaItalicWoff2}) format("woff2"),
        url(${NexaItalicWoff}) format("woff");
        font-display: swap;
    }

    @font-face {
        font-family: "Nexa";
        font-style: normal;
        font-weight: bold;
        src: url(${NexaBoldOtf}), url(${NexaBoldWoff2}) format("woff2"),
        url(${NexaBoldWoff}) format("woff");
        font-display: swap;
    }

    @font-face {
        font-family: "Nexa";
        font-style: italic;
        font-weight: bold;
        src: url(${NexaBoldItalicOtf}), url(${NexaBoldItalicWoff2}) format("woff2"),
        url(${NexaBoldItalicWoff}) format("woff");
        font-display: swap;
    }

    body {

        --color-primary-h: 225;
        --color-primary-s: 53%;
        --color-primary-l: 30%;

        --color-primary-fg-h: 0;
        --color-primary-fg-s: 0%;
        --color-primary-fg-l: 100%;

        --color-secondary-h: 198;
        --color-secondary-s: 100%;
        --color-secondary-l: 44%;

        --color-secondary-fg-h: 0;
        --color-secondary-fg-s: 0%;
        --color-secondary-fg-l: 100%;

        --color-tertiary-h: 51;
        --color-tertiary-s: 100%;
        --color-tertiary-l: 49%;

        --color-tertiary-fg-h: 225;
        --color-tertiary-fg-s: 53%;
        --color-tertiary-fg-l: 30%;

        --color-primary-light-h: var(--color-primary-h);
        --color-primary-light-s: calc(var(--color-primary-s) - 3%);
        --color-primary-light-l: calc(var(--color-primary-l) + 62%);

        --color-primary-extra-light-h: calc(var(--color-primary-h) - 6);
        --color-primary-extra-light-s: calc(var(--color-primary-s) + 47%);
        --color-primary-extra-light-l: calc(var(--color-primary-l) + 68%);

        --color-secondary-tint-h: var(--color-secondary-h);
        --color-secondary-tint-s: calc(var(--color-secondary-s) - 10%);
        --color-secondary-tint-l: calc(var(--color-secondary-l) - 5%);

        --color-secondary-light-h: var(--color-secondary-h);
        --color-secondary-light-s: var(--color-secondary-s);
        --color-secondary-light-l: calc(var(--color-secondary-l) + 48%);

        --color-secondary-extra-light-h: var(--color-secondary-h);
        --color-secondary-extra-light-s: var(--color-secondary-s);
        --color-secondary-extra-light-l: calc(var(--color-secondary-l) + 53%);

        --color-tertiary-tint-h: var(--color-tertiary-h);
        --color-tertiary-tint-s: calc(var(--color-tertiary-s) - 15%);
        --color-tertiary-tint-l: calc(var(--color-tertiary-l) + 3%);

        --color-primary: hsl(var(--color-primary-h),
        var(--color-primary-s),
        var(--color-primary-l));

        --color-primary-fg: hsl(var(--color-primary-fg-h),
        var(--color-primary-fg-s),
        var(--color-primary-fg-l));

        --color-primary-light: hsl(var(--color-primary-light-h),
        var(--color-primary-light-s),
        var(--color-primary-light-l));

        --color-primary-extra-light: hsl(var(--color-primary-extra-light-h),
        var(--color-primary-extra-light-s),
        var(--color-primary-extra-light-l));

        --color-secondary: hsl(var(--color-secondary-h),
        var(--color-secondary-s),
        var(--color-secondary-l));

        --color-secondary-fg: hsl(var(--color-secondary-fg-h),
        var(--color-secondary-fg-s),
        var(--color-secondary-fg-l));

        --color-secondary-tint: hsl(var(--color-secondary-tint-h),
        var(--color-secondary-tint-s),
        var(--color-secondary-tint-l));

        --color-secondary-light: hsl(var(--color-secondary-light-h),
        var(--color-secondary-light-s),
        var(--color-secondary-light-l));

        --color-secondary-light-03: hsla(var(--color-secondary-light-h),
        var(--color-secondary-light-s),
        var(--color-secondary-light-l),
        .3);

        --color-tertiary: hsl(var(--color-tertiary-h),
        var(--color-tertiary-s),
        var(--color-tertiary-l));

        --color-tertiary-fg: hsl(var(--color-tertiary-fg-h),
        var(--color-tertiary-fg-s),
        var(--color-tertiary-fg-l));

        --color-tertiary-tint: hsl(var(--color-tertiary-tint-h),
        var(--color-tertiary-tint-s),
        var(--color-tertiary-tint-l));

        --color-selected: hsl(var(--color-secondary-extra-light-h),
        var(--color-secondary-extra-light-s),
        var(--color-secondary-extra-light-l));

        --color-success: #49bc74;
        --color-success-light: #EEF7EE;

        --color-warning: #F48026;
        --color-warning-light: #FFF4e6;

        --color-error: #f65b51;
        --color-error-light: #fdeceb;

        --color-info: #3b6ecb;
        --color-info-light: #e9f4fd;

        --color-pending: #fffbe6;

        --color-grey-900: #50555c;
        --color-grey-800: #888;
        --color-grey-700: #dadada;
        --color-grey-600: #eee;
        --color-grey-500: #f6f5f5;
        --color-grey-400: #fafafa;

        --color-white: #fff;

        --color-itsme: #ff4612;
        --color-itsme-label-hover: #343637;

        --color-light-hover: rgba(0, 0, 0, 0.08);

        --size-8: 0.8rem;
        --size-10: 1rem;
        --size-12: 1.2rem;
        --size-14: 1.4rem;
        --size-16: 1.6rem;
        --size-18: 1.8rem;
        --size-20: 2rem;
        --size-24: 2.4rem;
        --size-32: 3rem;

        --radius-5: 5px;
        --radius-10: 10px;
        --radius-15: 15px;
        --radius-20: 20px;
        --radius-50: 50%;
        --radius-top-10: 10px 10px 0 0;
        --radius-bottom-10: 0 0 10px 10px;
        --font-nexa: "Nexa", sans-serif;
        --weight-600: 600;

        --max-page-width: 1240px;
    }

    [data-theme-variant="pro"] {
        --color-grey-400: #F1F2F6;
        --color-secondary-light: var(--color-primary-light);

    }

    html {
        font-family: var(--font-nexa);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background-color: var(--color-grey-700);
    }

    /* width */
    ::-webkit-scrollbar,
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-thumb {
        width: 5px;
        border-radius: var(--radius-15);
    }

    ::-webkit-scrollbar:horizontal,
    ::-webkit-scrollbar-track:horizontal,
    ::-webkit-scrollbar-thumb:horizontal {
        height: 5px;
        border-radius: var(--radius-15);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        width: 5px;
        background: var(--color-grey-700);
    }

    ::-webkit-scrollbar-thumb:horizontal {
        background-color: var(--color-grey-700);
    }

    ::-webkit-scrollbar-thumb:horizontal:hover {
        height: 5px;
        background-color: var(--color-grey-700);
    }

    *:focus {
        outline: none;
    }

    input {
        &::-ms-reveal {
            display: none;
        }

        &::-ms-clear {
            display: none;
        }
    }

    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
    }

    .hidden-on-mobile {
        @media ${breakpoints.xs} {
            display: none;
        }
    }

    .hideNumberCarousel input[type=number]::-webkit-inner-spin-button,
    .hideNumberCarousel input[type=number]::-webkit-outer-spin-button {
        appearance: none;
        margin: 0;
    }

    .pointer {
        cursor: pointer;
    }

    .hyperlink {
        color: var(--color-primary);
        text-decoration-line: underline;
        cursor: pointer;
    }

    .textUnderline {
        cursor: pointer;
        text-decoration: underline;
    }

    .d-flex {
        display: flex;
    }

    .float-right {
        float: right;
    }

    .flex1 {
        flex: 1;
    }

    .align-center {
        align-items: center;
    }

    .place-items-flex-start {
        place-items: flex-start;
    }

    .justify-center {
        justify-content: center;
    }

    .justify-end {
        justify-content: flex-end;
    }

    .justify-space-between {
        justify-content: space-between;
    }

    .mr10.mr10.mr10 {
        margin-right: 10px;
    }

    .mr0 {
        margin-right: 0;
    }

    .mb0 {
        margin-bottom: 0 !important;
    }

    .mb4.mb4.mb4 {
        margin-bottom: 4px;
    }

    .mb10.mb10.mb10 {
        margin-bottom: 10px;
    }

    .mb20.mb20.mb20 {
        margin-bottom: 20px;
    }

    .mb16.mb16.mb16 {
        margin-bottom: 16px;
    }

    .mb20 {
        margin-bottom: 20px;
    }

    .mt0.mt0.mt0 {
        margin-top: 0;
    }

    .mt10.mt10.mt10 {
        margin-top: 10px;
    }

    .mt16.mt16.mt16 {
        margin-top: 16px;
    }

    .mt8.mt8.mt8 {
        margin-top: 8px;
    }

    .mt20.mt20.mt20 {
        margin-top: 20px;
    }

    .mt24.mt24.mt24 {
        margin-top: 24px;
    }

    .mt40.mt40.mt40 {
        margin-top: 40px;
    }

    .mt48.mt48.mt48 {
        margin-top: 48px;
    }

    .ml10 {
        margin-left: 10px;
    }

    .flex-wrap {
        flex-wrap: wrap;
    }

    .full-width {
        width: 100%;
    }

    .form-label {
        margin: 1.2rem 0 0.4rem 0;
        font-size: var(--size-16);
        line-height: 22px;
        color: var(--color-grey-800);
        text-align: left;
    }

    .checkboxInput.error.MuiCheckbox-root {
        color: red;
    }

    .form-label-checkbox {
        font-size: var(--size-16);
        font-weight: var(--weight-600);
        line-height: 22px;
        color: var(--color-grey-800);
        text-align: left;
    }

    input:-internal-autofill-selected {
        -webkit-text-fill-color: var(--color-grey-900);
    }

    h2 {
        margin: 0;
        font-size: var(--size-32);
        font-weight: bold;
        line-height: 40px;
        color: var(--color-primary);
        @media ${breakpoints.sm} {
            font-size: var(--size-20);
        }
        @media ${breakpoints.xs} {
            font-size: var(--size-16);
        }
    }

    h1 {
        font-size: var(--size-32);
        font-weight: bold;
        color: var(--color-primary-fg);
    }

    .adornment {
        display: flex;
        justify-content: center;
        width: 2.25rem;
        cursor: pointer;
    }


    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
        box-shadow: 0 0 0 30px white inset !important;
    }


    .highlight {
        padding: 4px 0;
        font-weight: bold;
        color: var(--color-secondary);
        background-color: var(--color-secondary-light);
        border-radius: var(--radius-5);
    }

    .title {
        padding-bottom: 3rem;
        margin: 0;
        font-size: var(--size-32);
        font-weight: bold;
        line-height: 48px;
        color: var(--color-primary);
        text-align: center;
        @media ${breakpoints.xs} {
            padding-bottom: 1.5rem;
            font-size: var(--size-18);
            line-height: 40px;
        }
    }

    .header {
        .title {
            font-size: var(--size-20);
            line-height: 30px;
        }
    }


    .paper-line {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        height: 48px;
        padding: 12px 16px;
        margin-bottom: 16px;
        background: var(--color-white);
        border-radius: var(--radius-5);
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    }

    .__rcs-handle-root {
        .__rcs-handle-line {
            color: var(--color-secondary) !important;
        }

        .__rcs-handle-button {
            color: var(--color-secondary) !important;
        }
    }

    .select-menu-list-without-padding {
        .MuiMenu-paper {
            .MuiMenu-list {
                padding: 0;
            }
        }
    }

    label.Mui-disabled.Mui-error {
        color: rgba(0, 0, 0, 0.38);
    }

`;

export default GlobalStyle;
